import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Fact } from '../models/Fact';
import localConfig from '../config';
const baseAPIURL = window.config.factApiUrl;
const apiKey = localConfig.factApiKey;
// Common base API setup
export const funFactApi = createApi({
  reducerPath: 'funFactApi',
  baseQuery: fetchBaseQuery({
    baseUrl: baseAPIURL,
    prepareHeaders: (headers) => {
      if (apiKey) {
        headers.set('x-api-key', apiKey);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getFunfact: builder.query<Fact[], void>({
      query: () => 'facts',
    }),
  }),
});
// Export hooks for usage in functional components
export const { useGetFunfactQuery } = funFactApi;
